import moment from 'moment';
import { DAYS_OF_WEEK } from '@/components/broadcast/constants/smsBroadcast.constants';

export const getNextWeekday = (now) => {
    const {
        FRIDAY, SATURDAY, NEXT_MONDAY,
    } = DAYS_OF_WEEK;

    const date = moment(now);

    return [FRIDAY, SATURDAY].includes(date.day())
        ? date.day(NEXT_MONDAY)
        : date.add(1, 'days');
};
